import i18n from 'i18next'
export * from './II18nValueConf'
export const fanfanloI18n = i18n;
export * from './i18n-value-loader'
export * from './i18n-init'
export * from './lng'
export * from './useLanguages'
/// 不要用i18nSetting